import { globalStyles } from "@client/shared/constants";
const { display, background, flex, text } = globalStyles;

const styles = {
  drawerClose: {
    // ...background.color.primary.dark,
    backgroundColor: "grey.100",
    ...flex.justify.between,
    maxWidth: "68px",
    minWidth: "56px",
    cursor: "pointer",
  },
  content: {
    marginLeft: "75px",
  },
  drawerOpen: {
    width: "248px",
    marginTop: "65px",
    // ...background.color.primary.dark,
    backgroundColor: "grey.100",
    ...flex.justify.between,
    // zIndex: (theme) => theme.zIndex.drawer + 2,
    cursor: "pointer",
    border: "0.5px solid rgb(224,224,224)",
  },
  iconContainer: {
    width: "100%",
    ...text.align.center,
  },
  container: {
    width: "100%",
    flexDirection: "column",
    ...display.flex,
    ...flex.align.center,
  },
  drawerList: {
    ...display.flex,
    flexDirection: "column",
    marginTop: "14px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "start",
  },
  drawerButtonActive: {
    backgroundColor: "white",
    padding: "8px 20px",
    color: "primary.dark",
    marginTop: "18px",
    "&:hover": {
      backgroundColor: "white !important",
    },
    minWidth: "268px",
    justifyContent: "start",
  },
  drawerButtonClose: {
    backgroundColor: "white",
    minWidth: "40px",
    minHeight: "40px",
    margin: "10px",
    "&:hover": {
      backgroundColor: "white !important",
    },
  },
  drawerButton: {
    marginTop: "12px",
    color: "white",
  },
  drawerButtonInActive: {
    padding: "12px 20px",
    marginTop: "16px",
    color: "grey.600",
    justifyContent: "start",
    minWidth:"268px"
  },
  logoOpen: {
    // marginTop: "8px",
    height: "44px",
    width: "114px",
  },
  logo: {
    width: "28px",
    height: "28px",
    // marginTop: "12px",
  },
  textColor: {
    color: "#6258de",
    borderColor: "#6258de",
    fontSize:"20px",
  },
  textInactiveColor: {
    fontSize:"18px",
  },
};

export default styles;
